
<span v-if="props.required" class="text-danger"> * </span>
